import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Loading from "../../Common/Loading";
import Message from "../../components/Message";
import { userProfileData } from "../../Common/profileInfo";
import { FaRegWindowClose } from "@react-icons/all-files/fa/FaRegWindowClose";
import { formatPhone, emailIsValid } from "../../functions/misc";
import { clientConfig } from "../../awsClientConfig";
import { GetProtectionPlans } from "../../queries/GetProtectionPlans";
import { CreateLead } from "../../queries/CreateLead";
import { GetPartner } from "../../queries/GetPartner";

function SubmitReferral() {
  const [loading, setLoading] = useState(false);
  const client = new clientConfig();
  const navigate = useNavigate();
  const [submited, setSubmited] = useState(false);
  const [profile, setProfile] = useState({ firstName: "", lastName: "", email: "", phone: "", isQualified: false, consentToDisclose: false });
  const [error, setError] = useState({ firstName: "", lastName: "", email: "", phone: "", isQualified: false, consentToDisclose: false });
  const [recommendedProtectionPlanId, setRecommendedProtectionPlanId] = useState();
  const [show, setShow] = useState(false);

  const handleOnChange = (event: any) => {
    const newProfile = { ...profile, [event.target.name]: event.target.value };
    setProfile(newProfile);
  };

  const handleOnCheck = (event: any) => {
    const newProfile = {
      ...profile,
      [event.target.name]: event.target.checked
    };
    setProfile(newProfile);
  };

  const validateFormData = (firstName: string, lastName: string, email: string, phone: string) => {
    let _error = error;
    if (!email) {
      error["email"] = "Email can not be empty";
    } else if (!emailIsValid(email)) {
      error["email"] = "Email is invalid";
    } else {
      error["email"] = "";
    }
    if (!firstName) {
      error["firstName"] = "FirstName can not be empty";
    } else {
      error["firstName"] = "";
    }
    if (!lastName) {
      error["lastName"] = "LastName can not be empty";
    } else {
      error["lastName"] = "";
    }

    if (!phone) {
      error["phone"] = "Phone can not be empty";
    } else {
      error["phone"] = "";
    }
    setError(_error);
    setError({ ...error });
  };

  const addReferral = async (event: any) => {
    const partnerId = await userProfileData();
    event.preventDefault();
    event.stopPropagation();
    setLoading(true);
    setSubmited(true);
    client
      .mutate({
        mutation: CreateLead,
        variables: {
          PartnerId: partnerId,
          Email: profile.email,
          FirstName: profile.firstName,
          LastName: profile.lastName,
          Phone: profile.phone.replace(/[^\d]/g, ""),
          IsQualified: profile.isQualified,
          ConsentToDisclose: profile.consentToDisclose,
          RecommendedProtectionPlanId: recommendedProtectionPlanId,
        }
      })
      .then((res: any) => {
        setProfile({ firstName: "", lastName: "", email: "", phone: "", isQualified: false, consentToDisclose: false });
        setSubmited(false);
        setShow(true);
        setLoading(false);
      })
      .catch((err) => {
        if (err.errors[0].message.includes("Email is associated with an Account already.")) {
          let _error = error;
          error["email"] = "There is an account associated with this email address.";
          setError(_error);
          setError({ ...error });
          return;
        }
        if (err.errors[0].message.includes("Email is associated with an existing Lead.")) {
          let _error = error;
          error["email"] = "Email is associated with an existing Lead.";
          setError(_error);
          setError({ ...error });
        }
        setLoading(false);
        console.log("addReferral " + err.errors[0].message);
      });
  };

  const getPlans = async () => {
    const profileId = await userProfileData();
    const data: any = await client.query({
      query: GetProtectionPlans,
      variables: {
        ProfileId: profileId
      }
    })
      .then((response: any) => {
        console.log(response);
        const protectionPartnerMonitoring = response.data.GetProtectionPlans.find(
          (plan: any) => plan.Name === "Free"
        );
        setRecommendedProtectionPlanId(protectionPartnerMonitoring.Id);
      }).catch((err: any) => {
        console.log("getPlans: " + err);
      });
  };

  const getPartner = async () => {
    const partnerId = await userProfileData();
    client
      .query({
        query: GetPartner,
        variables: {
          PartnerId: partnerId
        }
      })
      .then((response) => {
        console.log(response);
      });
  };

  useEffect(() => {
    validateFormData(
      profile.firstName,
      profile.lastName,
      profile.email,
      profile.phone
    );
  }, [profile]);

  useEffect(() => {
    setLoading(false);
    getPartner();
    getPlans();
  }, []);

  return (
    <section className="submitReferral">
      <Card className="border-0 w-100">
        <Card.Body>
          <h6 className="mt-3 ff-Montserrat fs-6">
            Submit a Referral
          </h6>
          <p className="content-text text-secondary" style={{ fontSize: "0.8rem" }}>
            Fill out your client's contact information to refer them
            to Optima's Protection Plan.
          </p>
          {loading ? <Loading /> :
            <Form>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="firstName">
                  <Form.Label>
                    First Name <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control value={profile.firstName} name="firstName" onChange={handleOnChange} type="text" />
                  {submited && error.firstName && (
                    <Message message={error.firstName} type="error"></Message>
                  )}
                </Form.Group>
                <Form.Group as={Col} controlId="lastName">
                  <Form.Label>
                    Last Name <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control value={profile.lastName} name="lastName" onChange={handleOnChange} type="text" />
                  {submited && error.lastName && (
                    <Message message={error.lastName} type="error"></Message>
                  )}
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="email">
                  <Form.Label>
                    Email <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control name="email" value={profile.email} onChange={handleOnChange} type="text" />
                  {submited && error.email && (
                    <Message message={error.email} type="error" />
                  )}
                </Form.Group>
                <Form.Group as={Col} controlId="phone">
                  <Form.Label>
                    Phone <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control name="phone" value={formatPhone(profile.phone)} onChange={handleOnChange} type="text" />
                  {submited && error.phone && (
                    <Message message={error.phone} type="error"></Message>
                  )}
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="product">
                  <Form.Label>
                    Product
                  </Form.Label>
                  <Form.Select name="product" onChange={handleOnChange}>
                    <option value={'TaxShield'}>{'Tax Shield'}</option>
                    <option value={'TaxRelief'}>{'Tax Relief'}</option>
                  </Form.Select>
                </Form.Group>
              </Row>
              <Form.Group className="mb-3" controlId="checkBox1">
                <Form.Check className="text-muted fs-8" checked={profile.consentToDisclose} name="consentToDisclose" onChange={handleOnCheck} type="checkbox"
                  label="I hereby represent and warrant that I have obtained the proper consent to disclose Client Information to Optima and its affiliates from the respective Client prior to submitting any Client Information contained in the Referral to Optima."
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="checkBox2">
                <Form.Check className="text-muted fs-8" checked={profile.isQualified} name="isQualified" onChange={handleOnCheck} type="checkbox"
                  label="I've reviewed the eligibility requirement with this client."
                />
              </Form.Group>
              <Row>
                <Col md={8}>
                  <button onClick={() => { navigate("/partner-settings-url-qrcode-sharing"); }} className="letsdolater" style={{ border: "none", background: "none", fontWeight: 500 }}>
                    Want to refer multiple customers? Use a URL instead{" "}
                    {">"}
                  </button>
                </Col>
                <Col md={4} className="d-flex justify-content-end mb-2 mt-0">
                  <button onClick={addReferral} className="btn-default">
                    Submit
                  </button>
                </Col>
              </Row>
            </Form>
          }
        </Card.Body>
      </Card>
      <Modal show={show} onHide={() => { setShow(false); }} centered>
        <Modal.Header className="ms-auto border-0 color-primary">
          <FaRegWindowClose onClick={() => { setShow(false); }} />
        </Modal.Header>
        <Modal.Body className="px-5">
          <h5 style={{ textAlign: "center" }} className="color-primary ff-Montserrat fs-2 mt-0">
            Success!
          </h5>
          <p className="content-text">
            We will contact the referral within 48 hours and keep you updated on
            progress.
          </p>
          <div className="d-block mx-auto  text-center">
            <button onClick={() => { setShow(false); }} className="btn-continue mb-2 mt-2">
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  )
}

export default SubmitReferral;